import { error, finish } from '../../../modules/selections/actions/update';
import api from '../../../api';

export function request(dispatch, { id, eventId, marketId, selection }) {
    if (selection.betLimits) {
        for (let limit in selection.betLimits) {
            selection.betLimits[limit] = +selection.betLimits[limit] * 100;
        }
    }

    api.patch(`/events/${eventId}/markets/${marketId}/selections/${id}`, selection).then(
        (data) => dispatch(finish(id, data)),
        (errors) => dispatch(error(id, errors))
    );
}
